export default __webpack_public_path__ + "static/media/rewards-comp.0822b38a.png";